"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class RecordService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'user/record/integration-dev';
        this.getGenerateToken = async (params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/generate-token?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postGenerateToken = async (params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/generate-token?${queryString}`;
            const response = await axios_1.default.post(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.objectToQueryString = (obj) => Object.keys(obj).map(key => {
            const value = obj[key];
            let parameter = `${key}=${value}`;
            if (Array.isArray(value)) {
                let multiValueParams = '';
                const lastIndex = value.length - 1;
                value.forEach((item, index) => multiValueParams += `${key}=${item}${index === lastIndex ? '' : '&'}`);
                return multiValueParams;
            }
            return parameter;
        }).join("&");
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.RecordService = RecordService;
